import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#ff5959",
      d: "M18 10a8 8 0 1 0-16 0 8 8 0 1 0 16 0zm-7.95 2.45a1 1 0 0 1 1 1v.1a1 1 0 0 1-1.004 1h-.1a1 1 0 0 1-.996-1v-.1a1 1 0 0 1 1-1h.1zm-1.05-2v-4a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0zM20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "warning-circle"}) } }